import WalletConnect from '../../src/legacy/WalletConnect';
export default WalletConnect;
